import { CreativeTagEvent } from '../../enums';
import { EventEmitter } from '../../types';

export class CreativeEventEmitter implements EventEmitter<CreativeTagEvent> {
  private callbacksMap: {
    [key in CreativeTagEvent]: ((evt?: Event) => void)[];
  } = {
    [CreativeTagEvent.CreativeInit]: [],
    [CreativeTagEvent.CreativeLoaded]: [],
    [CreativeTagEvent.CreativeRequested]: [],
    [CreativeTagEvent.CreativeLoadingFailed]: [],
    [CreativeTagEvent.CreativeAssetLoad]: [],
    [CreativeTagEvent.CreativeDisplay]: [],
    [CreativeTagEvent.CreativeView]: [],
    [CreativeTagEvent.CreativeTimespent]: [],
    [CreativeTagEvent.CreativeShow]: [],
    [CreativeTagEvent.CreativeClicked]: [],
    [CreativeTagEvent.CreativeReached]: [],
    [CreativeTagEvent.CreativeCompleted]: [],
    [CreativeTagEvent.CreativeChapterViewed]: [],
    [CreativeTagEvent.CreativeNavigationSlide]: [],
    [CreativeTagEvent.CreativeNavigationSiteScroller]: [],
    [CreativeTagEvent.CreativeRedirection]: [],
    [CreativeTagEvent.VideoStart]: [],
    [CreativeTagEvent.VideoFirstQuartile]: [],
    [CreativeTagEvent.VideoMidpoint]: [],
    [CreativeTagEvent.VideoThirdQuartile]: [],
    [CreativeTagEvent.VideoComplete]: []
  };

  public addEventListener(
    event: CreativeTagEvent,
    callback: (evt?: Event) => void
  ) {
    if (!this.callbacksMap[event]) {
      return;
    }

    this.callbacksMap[event].push(callback);
  }

  public emit(event: CreativeTagEvent, evt?: Event) {
    if (!this.callbacksMap[event]) {
      return;
    }
    this.callbacksMap[event].forEach(callback => callback(evt));
  }
}
